import React from 'react'
import { ThemeProvider } from 'styled-components'

const colors = {
	white: '#ffffff',
	grey: ['#f6f6f6', '#b1b1b1', '#666666'],
	red: '#ea4c4a',
	blue: ['#3080eb', '#2e7ae2'],
	pink: '#f4617b',
	black: ['#323232', '#000000'],
}

const theme = {
	colors: {
		...colors,
		primary: colors.blue[0],
		accent: colors.pink,
	},
	font: {
		weight: {
			light: 300,
			normal: 400,
			bold: 600,
		},
	},
	shadows: {
		small: '0 1px 1px rgba(27, 31, 35, 0.1)',
		medium: '0 1px 5px rgba(27, 31, 35, 0.15)',
	},
}

const Provider = ({ children }) => (
	<ThemeProvider theme={theme}>{children}</ThemeProvider>
)

export { Provider }
